/**
 * Labstep
 *
 * @module components/ProtocolCollection/Action/Create
 * @desc Create Action for protocol
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import ProtocolCollectionActionCreateWithFolder from 'labstep-web/components/ProtocolCollection/Action/CreateWithFolder';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type { IRouting } from 'labstep-web/services/navigation.types';
import type React from 'react';
import type { IProtocolCollectionActionCreateProps } from './types';

export const ProtocolCollectionActionCreate: React.FC<
  IProtocolCollectionActionCreateProps
> = ({ body = {}, actionComponentProps, activeGroup }) => {
  const { entityName } = ProtocolCollection;

  const folderId = body?.folder_id;
  if (
    !folderId &&
    activeGroup &&
    !activeGroup.is_unsorted_folder_protocol_collection_enabled &&
    !activeGroup.default_protocol_collection_folder
  ) {
    return (
      <ProtocolCollectionActionCreateWithFolder
        actionComponentProps={actionComponentProps}
      />
    );
  }

  return (
    <EntityActionCreate
      entityName={entityName}
      actionComponentProps={{
        type: 'button',
        ...actionComponentProps,
      }}
      redirectRoute={({ response }) => ({
        to: `${entityName}_show` as keyof IRouting,
        params: { id: response.result },
      })}
      body={body}
    />
  );
};

export default withActiveGroup(ProtocolCollectionActionCreate);
